<script setup>
import aeonisLogo from "@/assets/images/aeonis_logo_white.svg";
import {useUserStore} from "@/stores/user.js";

const userStore = useUserStore();
</script>

<template>
  <nav class="w-full bg-gray-700 fixed flex justify-between text-neutral-100 px-2 z-9">
    <ul class="flex">
      <li>
        <router-link class="p-4 border-b-2 border-gray-700 flex" :to="{name: 'home'}">
          <img class="h-[25px]" :src="aeonisLogo" alt="Aeonis Logo" />
          <span class="pl-2 font-bold">Aeonis</span>
        </router-link>
      </li>
      <li class="flex">
        <router-link class="content-center px-2 mx-2 cursor-pointer border-b-2 border-gray-700 hover:border-neutral-100" :to="{name: 'home', hash: '#summary'}">
          Summary
        </router-link>
      </li>
      <li class="flex">
        <router-link class="content-center px-2 mx-2 cursor-pointer border-b-2 border-gray-700 hover:border-neutral-100" :to="{name: 'home', hash: '#pricing'}">
          Pricing
        </router-link>
      </li>
      <li class="flex">
        <router-link class="content-center px-2 mx-2 cursor-pointer border-b-2 border-gray-700 hover:border-neutral-100" :to="{name: 'home', hash: '#roadmap'}">
          Roadmap
        </router-link>
      </li>
    </ul>

    <ul v-if="userStore.user" class="flex">
      <li class="flex">
        <router-link class="content-center px-2 mx-2 inline-block border-b-2 border-gray-700 hover:border-neutral-100"
                     :to="{name: 'dashboard'}">
          Dashboard
        </router-link>
      </li>
    </ul>

    <ul v-else class="flex">
      <li class="flex">
        <router-link class="content-center px-2 mx-2 inline-block border-b-2 border-gray-700 hover:border-neutral-100"
                     :to="{name: 'login'}">
          Login
        </router-link>
      </li>

      <li class="flex">
        <router-link class="content-center px-2 mx-2 inline-block border-b-2 border-gray-700 hover:border-neutral-100"
                     :to="{name: 'register'}">
          Register
        </router-link>
      </li>
    </ul>
  </nav>
</template>
